import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import { SearchBarContainer } from "../shared-components/searchInput/search-input-styles";
import NewsSearchContext from "../../../application/Context/NewsSearchContext";
import { SearchInput } from "../shared-components/searchInput/SearchInput";
export var SearchBar = function () {
    var _a = React.useContext(NewsSearchContext), searchInput = _a.searchInput, handleSearchInput = _a.handleSearchInput, searchNews = _a.searchNews, handleKeyDown = _a.handleKeyDown;
    var t = useTranslation(["common"]).t;
    return (_jsxs(SearchBarContainer, { children: [_jsx("label", { htmlFor: "searchinput", style: { display: "none" }, children: t("Search") }), _jsx(SearchInput, { id: "searchinput", placeholder: t("Search"), type: "text", value: searchInput, onChange: handleSearchInput, handleSearch: searchNews, onKeyDown: handleKeyDown })] }));
};
